<template>
    <div class="resumeOther">
        <el-row>
            <el-col :span="4" class="resumeItem">
                <h1>简历关键词</h1>
            </el-col>
            <el-col :span="20">
                <el-tag class="label_margin" v-for="item in resumeInfo.keywordList" :key="item.id">{{item.labelName}}</el-tag>
            </el-col>
        </el-row>
    </div>
</template>
<script>
    export default {
        name: 'ResumeKeyword',
        props: ['resumeInfo']
    }
</script>
<style scoped>
    .label_margin { margin-right: 10px}
</style>